import React from 'react'
import CurrencyFormat from 'react-currency-format'

import LabelDetail from '../../UI/Label/LabelDetail'
import LabelDetailHtml from '../../UI/Label/LabelDetailHtml'


const Project = props => {
    const { year, modality, inegi_code, state, municipality, code, name, objective, justification,
        total_goals, total_expenses, application_amount, approved_amount, disbursed_amount } = props.project

    return (
        <div className="columns">
            <div className="column">
                <table className='table is-bordered is-fullwidth table-info'>
                    <tbody>
                        <tr>
                            <td>
                                <LabelDetail
                                    title='año'
                                    description={year}
                                />
                            </td>
                            <td>
                                <LabelDetail
                                    title='modalidad'
                                    description={modality}
                                />
                            </td>
                            <td>
                                <LabelDetail
                                    title='clave inegi'
                                    description={inegi_code}
                                />
                            </td>
                            <td>
                                <LabelDetail
                                    title='entidad'
                                    description={state}
                                />
                            </td>
                            <td>
                                <LabelDetail
                                    title='municipio'
                                    description={municipality}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <LabelDetail
                                    title='folio'
                                    description={code}
                                />
                            </td>
                            <td colSpan="4">
                                <LabelDetail
                                    title='nombre'
                                    description={name}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="5">
                                <LabelDetailHtml
                                    title='objetivo'
                                    description={objective}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="5">
                                <LabelDetailHtml
                                    title='justificación'
                                    description={justification}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan='3' width="50%">
                                <LabelDetail
                                    title='total metas'
                                    description={
                                        <CurrencyFormat
                                            value={parseFloat(total_goals) || 0}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'$'}
                                        />
                                    }
                                />
                            </td>
                            <td colSpan='2' width="50%">
                                <LabelDetail
                                    title='total gastos de operación'
                                    description={
                                        <CurrencyFormat
                                            value={parseFloat(total_expenses) || 0}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'$'}
                                        />
                                    }
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan='2'>
                                <LabelDetail
                                    title='monto solicitado'
                                    description={
                                        <CurrencyFormat
                                            value={parseFloat(application_amount) || 0}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'$'}
                                        />
                                    }
                                />
                            </td>
                            <td colSpan='2'>
                                <LabelDetail
                                    title='monto aprobado'
                                    description={
                                        <CurrencyFormat
                                            value={parseFloat(approved_amount) || 0}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'$'}
                                        />
                                    }
                                />
                            </td>
                            <td colSpan='1'>
                                <LabelDetail
                                    title='monto ejercido'
                                    description={
                                        <CurrencyFormat
                                            value={parseFloat(disbursed_amount) || 0}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'$'}
                                        />
                                    }
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Project


// WEBPACK FOOTER //
// ./src/acervo/components/Sections/Detail/Project.js